module.exports = __webpack_public_path__ + "img/SOLDAGEM.3146c845.jpg";